import axios from 'axios'
import qs from 'qs'
import router from '../router'
// axios默认可修改Cookie
axios.defaults.withCredentials = true
// 全局路由拦截响应处理
axios.interceptors.response.use((config) => {
  // 处理之前的配置
  return config
}, (error) => {
  // 处理响应失败
  if (error && error.response) {
    switch (error.response.status) {
      case 401:
        error.message = '未授权,请重新登录(401)'
        alert('登录状态过期,请重新登录')
        router.push('/Login')
        break
      default:
        error.message = `链接出错(${error.response.status})`
    }
  } else {
    error.message = '链接服务器失败!'
  }
  // message.error(error.message)
  return Promise.reject(error)
})

let apiaddress
// if (window.location.hostname === 'help.aiyaopai.com') {

if (window.location.hostname === 'localhost') {
  apiaddress = 'https://node-help-api.aiyaopai.com'
} else {
  apiaddress = 'https://node-help-api.aiyaopai.com'
}
const api = {
  // 登录接口
  Login: '/api/login',
  // 文档管理
  DocManage: '/api/documents',
  // 更新列表
  UpdateList: '/api/updateinfo'
}
// 登录
const login = (UserName, Password) => {
  return new Promise((resolve, reject) => {
    let data = {
      UserName,
      Password
    }
    axios.post(apiaddress + api.Login, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 退出
const quit = () => {
  return new Promise((resolve, reject) => {
    axios.delete(apiaddress + api.Login).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 获取首页产品列表
const getProducts = (Hidden) => {
  return new Promise((resolve, reject) => {
    axios.get(apiaddress + api.DocManage, {
      params: {
        Hidden
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 创建产品
const createPro = (Name, Description, Hidden) => {
  return new Promise((resolve, reject) => {
    let data = {
      Name,
      Description,
      Hidden
    }
    axios.post(apiaddress + api.DocManage, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 修改产品信息
const changePro = (Name, Description, id, Hidden) => {
  return new Promise((resolve, reject) => {
    let data = {
      Name,
      Description,
      Hidden
    }
    axios.put(apiaddress + api.DocManage + '/' + id, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 获取文档管理
const getDoc = (id) => {
  return new Promise((resolve, reject) => {
    axios.get(apiaddress + api.DocManage + '/' + id).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 点击保存按钮,保存文档修改
const saveChange = (Contents, MdContents, id) => {
  return new Promise((resolve, reject) => {
    let data = {
      Contents,
      MdContents
    }
    axios.put(apiaddress + api.DocManage + '/' + id, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 获取更新通知内容列表
const getNoticeList = (id) => {
  return new Promise((resolve, reject) => {
    axios.get(apiaddress + api.UpdateList + '?id=' + id).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 获取单条通知信息
const apperNotice = (id) => {
  return new Promise((resolve, reject) => {
    axios.get(apiaddress + api.UpdateList + '/' + id).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 保存发布的新通知
const saveNewNotice = (Contents, MdContents, Versions, ProductId) => {
  return new Promise((resolve, reject) => {
    let data = {
      Contents,
      MdContents,
      Versions,
      ProductId
    }
    axios.post(apiaddress + api.UpdateList, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 编辑已发布的通知
const saveNotice = (Contents, MdContents, Versions, id) => {
  return new Promise((resolve, reject) => {
    let data = {
      Contents,
      MdContents,
      Versions
    }
    axios.put(apiaddress + api.UpdateList + '/' + id, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 删除单条通知
const deleteNotice = (id) => {
  return new Promise((resolve, reject) => {
    axios.delete(apiaddress + api.UpdateList + '/' + id).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 隐藏产品
// const hiddenPro = (Hidden) => {
//   return new Promise((resolve, reject) => {
//     axios.get(apiaddress + api.DocManage, {
//       params: {
//         Hidden
//       }
//     }).then(res => {
//       resolve(res)
//     }).catch(res => {
//       reject(res.response)
//     })
//   })
// }

export default {
  login,
  quit,
  getProducts,
  createPro,
  changePro,
  getDoc,
  saveChange,
  getNoticeList,
  apperNotice,
  saveNewNotice,
  saveNotice,
  deleteNotice
}



// WEBPACK FOOTER //
// ./src/api/api.js